'use client'

import { useEffect, useState } from 'react'

/**
 * Returns true only after the component has mounted and the browser has committed
 * the DOM (double rAF). Use this for Radix portals (Sheet, Dialog, Select, AlertDialog)
 * to avoid "removeChild" / "insertBefore" NotFoundError on slow networks and when
 * browser extensions (e.g. translation) modify the DOM before React finishes.
 * See: client_error removeChild on /es/signup, Colombia, etc.
 */
export function usePortalSafeMount(): boolean {
    const [ready, setReady] = useState(false)

    useEffect(() => {
        if (typeof document === 'undefined' || !document.body) {
            return
        }
        let cancelled = false
        const raf1 = requestAnimationFrame(() => {
            if (cancelled) return
            requestAnimationFrame(() => {
                if (cancelled) return
                setReady(true)
            })
        })
        return () => {
            cancelled = true
            cancelAnimationFrame(raf1)
        }
    }, [])

    return ready
}
